// extracted by mini-css-extract-plugin
export default {"distributeCollectionList":"DistributeCollection_distributeCollectionList__n4E-J","collectionNotFoundText":"DistributeCollection_collectionNotFoundText__crZuF"};